module.exports = __webpack_public_path__ + "img/png.9cdbae09.svg";